import axios from 'axios'
const ipService = {}
const DEFAULT_IP = '127.1.1.1'

ipService.getIpUser = async () => {
	try {
		const data = await axios.get('https://api.bigdatacloud.net/data/client-ip')
		const ip = data.data && data.data.ipString
		return ip || DEFAULT_IP
	} catch (err) {
		console.error(err) // eslint-disable-line
		return DEFAULT_IP
	}
}
export default ipService